import { humanizeCurrency } from '@/helpers/currency';
import { useUserHasPermission } from '@/hooks/usePermissions';
import { TimelogsPermissions } from '@payaca/permissions/timelogs/timelogs.permissions';
import { Text } from '@payaca/ambrosia';
import { FC } from 'react';
import { isoDurationToReadableString } from './ListedTimelogs';
import { useListedTimelogsContext } from './listedTimelogsContext';

/**
 * Slim combined-totals summary for the current filter/period, shown in the page
 * header bar (not inside the table grid). Reads the same account-wide
 * `totalDuration`/`totalCost` the query already returns, so it reflects the
 * selected period and filters and refreshes after an edit or delete.
 */
export const TimelogsTotalsSummary: FC = () => {
  const { queryResult } = useListedTimelogsContext();

  const hasCostPermission = useUserHasPermission({
    permissions: [TimelogsPermissions.GET_TIMELOG_COST_PER_HOUR],
  });

  const timelogs = queryResult?.data?.timelogs;

  if (!timelogs) return null;

  return (
    <span className="whitespace-nowrap normal-case text-gray-600">
      <Text as="span">
        <span className="font-semibold uppercase tracking-wide text-xs text-gray-500">
          Total
        </span>{' '}
        <span className="font-semibold">
          {isoDurationToReadableString(timelogs.totalDuration || 'PT0S')}
        </span>
        {hasCostPermission && (
          <>
            {' · '}
            <span className="font-semibold">
              {humanizeCurrency(timelogs.totalCost || 0)}
            </span>
          </>
        )}
      </Text>
    </span>
  );
};
